import type { SelectOption } from '@/shared/ui';
import { SettlementStatisticsRevenuePatchRequestRecurringTypeValue } from '../api/generated/model';

/**
 * 臨時経常区分の enum（短縮エイリアス）
 */
export const RecurringTypeValue = SettlementStatisticsRevenuePatchRequestRecurringTypeValue;
export type RecurringTypeValue = SettlementStatisticsRevenuePatchRequestRecurringTypeValue;

/**
 * 臨時経常区分の z.enum() 用バリュー配列
 */
export const recurringTypeValues = Object.values(RecurringTypeValue) as [
  RecurringTypeValue,
  ...RecurringTypeValue[],
];

/**
 * 臨時経常区分の SelectField 用オプション
 */
export const recurringTypeSelectOptions: SelectOption[] = Object.values(RecurringTypeValue).map(
  (value) => ({
    label: value,
    value,
  }),
);
